/**
 * Logout funnel: navigate to public `#/logout` (`z60-pagecomp/logout-page.jsx`),
 * which shows a spinner and calls `useLogin().logOut(returnTo)` so Auth0 end-session runs
 * after protected routes unmount — avoids `withAuthenticationRequired` racing logout.
 *
 * `returnTo` is always **origin + `/`** (no hash). Ensure Auth0 “Allowed Logout URLs” includes it.
 */

/** @returns {string} */
export function getPostLogoutReturnUrl() {
    return `${window.location.origin}/`;
}

/**
 * Go to `#/logout` (public). Optional callback runs first (e.g. close a dialog).
 * @param {function(): void} [onAfter]
 */
export function goToLogoutPage(onAfter) {
    onAfter?.();
    window.location.hash = "#/logout";
}

/**
 * @param {function(): void} [onAfter] — e.g. close dialog after logout is initiated
 */
export function scheduleLogoutFromHomeHash(onAfter) {
    goToLogoutPage(onAfter);
}
